import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { AuthGuard } from './services/auth.guard';
import { LoginComponent } from './pages/login/login.component';
import { HomeComponent } from './pages/home/home.component';
import { AreasComponent } from './pages/catalog/areas/areas.component';
import { ClientesComponent } from './pages/catalog/clientes/clientes.component';
import { ProyectosComponent } from './pages/catalog/proyectos/proyectos.component';
import { RolesComponent } from './pages/catalog/roles/roles.component';
import { UsuariosComponent } from './pages/catalog/usuarios/usuarios.component';
import { AreasDComponent } from './pages/catalog/areas/areas-d/areas-d.component';
import { ClientesDComponent } from './pages/catalog/clientes/clientes-d/clientes-d.component';
import { ProyectosDComponent } from './pages/catalog/proyectos/proyectos-d/proyectos-d.component';
import { RolesDComponent } from './pages/catalog/roles/roles-d/roles-d.component';
import { UsuariosDComponent } from './pages/catalog/usuarios/usuarios-d/usuarios-d.component';
import { FacturasComponent } from './pages/facturas/facturas.component';
import { FacturasDComponent } from './pages/facturas/facturas-d/facturas-d.component';
import { DeductivaComponent } from './pages/deductiva/deductiva.component';
import { PenalizacionComponent } from './pages/penalizacion/penalizacion.component';
import { DeductivaDComponent } from './pages/deductiva/deductiva-d/deductiva-d.component';
import { PenalizacionDComponent } from './pages/penalizacion/penalizacion-d/penalizacion-d.component';
import { RefacturacionComponent } from './pages/refacturacion/refacturacion.component';
import { RefacturacionDComponent } from './pages/refacturacion/refacturacion-d/refacturacion-d.component';
import { ReportesComponent } from './pages/reportes/reportes.component';
import { ReportesDsiComponent } from './pages/reportes/reportes-dsi/reportes-dsi.component';
import { AniosComponent } from './pages/catalog/anios/anios.component';
import { AniosDComponent } from './pages/catalog/anios/anios-d/anios-d.component';
import { ErrorComponent } from './pages/error/error.component';

const routes: Routes = [];

@NgModule({
  imports: [RouterModule.forRoot([

    { path: "", component: LoginComponent, pathMatch: "full" },
    { path: "login", component: LoginComponent, pathMatch: "full" },
    { path: "home", component: HomeComponent, canActivate: [AuthGuard] },

    { path: "areas", component: AreasComponent, canActivate: [AuthGuard] },
    { path: "clientes", component: ClientesComponent, canActivate: [AuthGuard] },
    { path: "proyectos", component: ProyectosComponent, canActivate: [AuthGuard] },
    { path: "anios", component: AniosComponent, canActivate: [AuthGuard] },
    
    { path: "roles", component: RolesComponent, canActivate: [AuthGuard] },
    { path: "usuarios", component: UsuariosComponent, canActivate: [AuthGuard] },

    { path: "facturas", component: FacturasComponent, canActivate: [AuthGuard] },
    { path: "refacturacion", component: RefacturacionComponent, canActivate: [AuthGuard] },
    { path: "deductiva", component: DeductivaComponent, canActivate: [AuthGuard] },
    { path: "penalizacion", component: PenalizacionComponent, canActivate: [AuthGuard] },

    { path: "areasD/:datos", component: AreasDComponent, canActivate: [AuthGuard] },
    { path: "clientesD/:datos", component: ClientesDComponent, canActivate: [AuthGuard] },
    { path: "proyectosD/:datos", component: ProyectosDComponent, canActivate: [AuthGuard] },
    { path: "rolesD/:datos", component: RolesDComponent, canActivate: [AuthGuard] },
    { path: "usuariosD/:datos", component: UsuariosDComponent, canActivate: [AuthGuard] },
    { path: "facturasD/:datos", component: FacturasDComponent, canActivate: [AuthGuard] },
    { path: "refacturacionD/:datos", component: RefacturacionDComponent, canActivate: [AuthGuard] },
    { path: "deductivaD/:datos", component: DeductivaDComponent, canActivate: [AuthGuard] },
    { path: "penalizacionD/:datos", component: PenalizacionDComponent, canActivate: [AuthGuard] },
    { path: "aniosD/:datos", component: AniosDComponent, canActivate: [AuthGuard] },
    
    { path: "facturaNueva", component: FacturasDComponent, canActivate: [AuthGuard] },
    { path: "reportes", component: ReportesComponent, canActivate: [AuthGuard] },
    { path: "reportesdsi", component: ReportesDsiComponent, canActivate: [AuthGuard] },

    { path: "error", component: ErrorComponent, pathMatch: "full" },

  ])],
  exports: [RouterModule]
})
export class AppRoutingModule { }
